import { z } from 'zod';

import { DeepPartial, deepPartial } from '../deep-partial';
import { UserSettings, userSettingsSchema } from './user-settings';

export type UpdateUserSettingsPayload = DeepPartial<UserSettings>;

export const updateUserSettingsPayloadSchema = deepPartial(userSettingsSchema) as z.ZodType<
  UpdateUserSettingsPayload,
  UpdateUserSettingsPayload
>;
